import './Hamburger.scss';
class Hamburger {
    constructor( node ) {
        this.node = node;
    }
    init() {
        let t = this;
        t.node.addEventListener('click', () => {
            t.node.classList.toggle('active');
        });

    }
}
JSModules['Hamburger'] = Hamburger;
export default Hamburger;